module.exports = __webpack_public_path__ + "static/media/2.9bc9b3da.svg";